import { css } from 'styled-components';

export const markdownStyles = css`
  font-size: 15px;
  line-height: 1.6;
  word-break: break-word;

  p {
    margin: 0 0 12px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 16px 0 8px;
  }

  ul,
  ol {
    margin: 8px 0;
    padding-left: 20px;
  }

  blockquote {
    margin: 8px 0;
    padding-left: 16px;
    border-left: 4px solid ${({ theme }) => theme.colors.grey2};
  }

  code {
    background: ${({ theme }) => theme.colors.grey1};
    padding: 2px 4px;
    border-radius: 3px;
    font-family: monospace;
    font-size: 14px;
    word-break: break-all;
  }

  pre {
    background: ${({ theme }) => theme.colors.grey1};
    padding: 12px;
    border-radius: 6px;
    overflow-x: auto;
    white-space: pre-wrap;
    code {
      background: transparent;
      padding: 0;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    margin: 12px 0;
    font-size: 14px;
    table-layout: fixed;
  }

  thead {
    background: ${({ theme }) => theme.colors.grey1};
  }

  th,
  td {
    border: 1px solid ${({ theme }) => theme.colors.grey2};
    padding: 6px 8px;
    text-align: left;
    word-break: break-word;
  }

  th {
    font-weight: 600;
  }

  p:last-child {
    margin-bottom: 0;
  }
`;
